/**
 * Shared customer image upload validation (profile, markers, covers, keepsakes).
 * HEIC/HEIF and SVG are intentionally excluded from this pass.
 */

export const CUSTOMER_IMAGE_UNSUPPORTED_MESSAGE =
  'This file type is not supported yet. Please upload a JPG, PNG, WebP, GIF or AVIF image.';

export const CUSTOMER_IMAGE_ACCEPT =
  'image/jpeg,image/jpg,image/png,image/webp,image/gif,image/avif,.jfif,.jpg,.jpeg,.png,.webp,.gif,.avif';

export const CUSTOMER_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'image/gif',
  'image/avif',
];

export const CUSTOMER_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'jfif', 'png', 'webp', 'gif', 'avif'];

export const CUSTOMER_IMAGE_FORMATS_LINE = 'JPG, PNG, WebP, GIF or AVIF';

export const IMAGE_PREVIEW_UNSUPPORTED_HINT =
  'Preview unavailable in this browser. You can still upload the file.';

const LEGACY_UNSUPPORTED_PATTERNS = [
  /only jpg and png/i,
  /only jpg, png/i,
  /please choose a jpg or png/i,
];

/** Map stale API validation copy to the current calm customer message. */
export function normalizeImageUploadErrorDetail(detail) {
  if (detail == null || detail === '') return detail;
  const text = String(detail);
  if (LEGACY_UNSUPPORTED_PATTERNS.some((re) => re.test(text))) {
    return CUSTOMER_IMAGE_UNSUPPORTED_MESSAGE;
  }
  return text;
}

function extensionFromName(filename) {
  const name = (filename || '').toLowerCase();
  const dot = name.lastIndexOf('.');
  return dot >= 0 ? name.slice(dot + 1) : '';
}

export function isCustomerImageFile(file) {
  if (!file) return false;
  const ext = extensionFromName(file.name);
  if (CUSTOMER_IMAGE_EXTENSIONS.includes(ext)) return true;
  const mime = (file.type || '').toLowerCase();
  return CUSTOMER_IMAGE_MIME_TYPES.includes(mime);
}

export function validateCustomerImageFile(file) {
  if (!file) {
    return { ok: false, message: 'Please choose an image file.' };
  }
  if (!isCustomerImageFile(file)) {
    return { ok: false, message: CUSTOMER_IMAGE_UNSUPPORTED_MESSAGE };
  }
  return { ok: true };
}

export function createCustomerImagePreviewUrl(file) {
  return URL.createObjectURL(file);
}

export function readCustomerImageDimensions(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error(IMAGE_PREVIEW_UNSUPPORTED_HINT));
    };
    img.src = url;
  });
}
